import * as ActionType from './contant'
import ls from 'utils/secureLocalStorage'

const STORAGE = 'currentRefresh'
const initState = null

const initializeState = () => {
  const config = ls.get(STORAGE)
  const state = config ? JSON.parse(config) : initState
  return state
}

const reducer = (state = initializeState(), action) => {
  const { type, value } = action

  switch (type) {
    case ActionType.SET_REFRESH:
      ls.set(STORAGE, JSON.stringify({ ...state, ...value }))
      return { ...state, ...value }
    case ActionType.CLEAR_REFRESH:
      ls.remove(STORAGE)
      return null
    default:
      return state
  }
}

export default reducer
